export default __webpack_public_path__ + "static/media/648.8adbb0df.png";